import DashboardWrapper from "src/components/common/DashboardWrapper";
import HorizontalTabs from "src/components/common/HorizontalTabs";
import EcoRestorationDashboard from "./ecoRestorationDashboard";
import CostEstimateDashboard from "./costEstimateDashboard";
import Entity from "./entityDashoard";
import EntityDetailV2 from "./entityDetailV2/index";
// import SelectedLandDashboard from "./selectedLand";
import FundApplicationDashboard from "./fundApplicationDashboard";
import FundDashboard from "../FundDashboard";
import ProgressReport from "./progressReport";
import NewSelectedLand from "./newSelected";
import DprDashboard from "./dpr";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { ADMIN_DASHBOARD_TAB_STORAGE_KEY } from "src/constants/common";
// import MouDashboard from "./mou";

const tabHeaders = [
  { label: "Eco-Restoration Blocks", value: "page1" },
  { label: "New Selected Land", value: "NewSelected" },
  { label: "Cost Estimates", value: "page2" },
  { label: "Entity Details", value: "Entity" },
  { label: "Entity Detail-v2", value: "EntityV2" },
  { label: "Fund Application", value: "FundApplication" },
  { label: "Fund Dashboard", value: "FundDashboard" },
  { label: "Progress Report", value: "ProgressReport" },
  { label: "DPR", value: "dpr" },
];

const MarketWatch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get("tab");
  const savedTab = localStorage.getItem(ADMIN_DASHBOARD_TAB_STORAGE_KEY);
  const requestedTabIndex = tabHeaders.findIndex(
    ({ value }) => value === requestedTab
  );
  const savedTabIndex = tabHeaders.findIndex(({ value }) => value === savedTab);
  const activeTabIndex =
    requestedTabIndex >= 0
      ? requestedTabIndex
      : savedTabIndex >= 0
      ? savedTabIndex
      : 0;

  useEffect(() => {
    localStorage.setItem(
      ADMIN_DASHBOARD_TAB_STORAGE_KEY,
      tabHeaders[activeTabIndex].value
    );
  }, [activeTabIndex]);

  const handleTabChange = (tab: string) => {
    localStorage.setItem(ADMIN_DASHBOARD_TAB_STORAGE_KEY, tab);
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <DashboardWrapper title="Dashboard" subTitle="">
      <HorizontalTabs
        tabHeaders={tabHeaders}
        tabIndex={activeTabIndex}
        onChange={handleTabChange}
        components={[
          <EcoRestorationDashboard />,
          <NewSelectedLand />,
          <CostEstimateDashboard />,
          <Entity />,
          <EntityDetailV2 />,
          <FundApplicationDashboard />,
          <FundDashboard embedded />,
          <ProgressReport />,
          <DprDashboard />,
          // <SelectedLandDashboard />,
          // <MouDashboard />,
        ]}
      />
    </DashboardWrapper>
  );
};

export default MarketWatch;
